const defaultState = {
	selectOptions: {
		plants: [],
		serviceKinds: [],
		pgmIds: [],
		procIds: []
	},

	searchParams: {
		plantCd: 'ALL',
		serviceKind: 'ALL',
		pgmId: 'ALL',
		procId: 'ALL'
	},

	pagingInfo: {
		currentPage: 1,
		pageUnit: 20
	},

	popupParams: {
		type: '',
		show: false,
		selectedRow: {},
		selectOptions: {
			procIds: []
		}
	},

	mappings: [],
	queues: [],
	pgmQueueMaps: []
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
